<div class="button-container" [ngClass]="class + (disabled ? ' disabled' : '') + (disableBorder ? ' no-border' : '')">
  <mat-icon *ngIf="icon?.type === 'people'">people</mat-icon>
  <mat-icon class="white" *ngIf="icon?.type === 'edit'">edit</mat-icon>
  <mat-icon color="white"  *ngIf="icon?.type === 'success'">check</mat-icon>
  <mat-icon *ngIf="icon?.type === 'close'">cancel</mat-icon>
  <mat-icon color="white" *ngIf="icon?.type === 'close circle'">cancel</mat-icon>
  <mat-icon class="mat-icon" *ngIf="icon?.materialIcon" fontSet="material-icons-round">{{icon?.materialIcon}}</mat-icon>
  <span class="klabel-large button">{{ text }}</span>
</div>
